

import React from 'react';

export default class CampaignStatusTag extends React.Component {
    render() {
        return this.props.status ? <button className={`btn btn-flat-${this.props.status.toLowerCase()}`}>{this.props.status}</button> : null;
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/CampaignStatusTag.jsx